import { render, staticRenderFns } from "./MasterTeachings.vue?vue&type=template&id=fdfd78aa&"
import script from "./MasterTeachings.vue?vue&type=script&lang=js&"
export * from "./MasterTeachings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports